import { ImageComponent, toPlaceholderImage } from '@frontend/internal-assets';
import type { ImageAssetProps } from '@frontend/internal-assets';
import optimizedImage from './image-assets/care-credit-financing-image.png';

const thumbHashString = 'eOeJJQQdd3hwiIAoOIiAgAgIBwd6h4GoFw==';
const placeholderImage = toPlaceholderImage(thumbHashString);

const calculatedAspectRatio = 0.9605911330049262;
const originalWidth = 390;

const CareCreditFinancingImage = ({
  aspectRatio = calculatedAspectRatio,
  width = originalWidth,
  ...rest
}: ImageAssetProps) => (
  <ImageComponent
    aspectRatio={aspectRatio}
    width={width}
    src={optimizedImage}
    placeholderSrc={placeholderImage}
    {...rest}
  />
);

export default CareCreditFinancingImage;
